import React from 'react';
//@ts-ignore
import parse from 'html-react-parser';
import ReactGA from 'react-ga4';

import { connect } from 'react-redux';
import { FormInstance } from 'antd/lib/form';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { v4 } from 'uuid';
import { FormattedMessage, injectIntl, WrappedComponentProps } from 'react-intl';
import { get, isEmpty } from 'lodash';

import { AppThunk, GetWalletNumber, RootState, getPreferenceFromAccount, getToken } from '@share/utils';
import {
  IReviewBookState,
  getBookPackageWithCard,
  setGuests,
  ICouponState,
  setPriceChangedError,
  setBooking,
  setBookingComplete,
  InsuranceSelection,
  IInsuranceState,
} from '@store/slices';
import {
  getNavigationMenu,
  IHotelsState,
  ILoginState,
} from '@share/store/slices';
import { BlueButton, Loading, LoadingSise } from '@share/components';
import { IBookingComplete, IBookPackageWithCard, IFormErrors, IGuestsBooking, ScrollBehaviorEnum } from '@common-types';
import { ISessionKey, LOGOUT_FIELD_KEY } from '@share/common-types';
import { UrlUtils, getSessionObj, renderNumber, getHotelRoutePath, getHotelIdFromPath, getSelectedCurrency, LoginType } from '@share/utils';
import { DEFAULT_GUEST_DATA, NON_REFUNDABLE_TYPE } from '@constants';
import { ReservationProgress, BookingConfirmed, BookingFailed, ReviewBookPriceChangeModal, AvailabilityStatusModal, ExpiredSessionModal, ThreeDSModal, ModalConfirmation, Insurance, Currency } from '@components';
import { SESSION_KEY_LABEL_ROOMS, SESSION_KEY_LABEL, C_COMPLETE_BOOKING, USER_BASE_URL, QUOTE_LABEL, Routes, SESSION_KEY_TOKEN_NAME_PARAM, LIFE_STYLE_NAME_PARAM } from '@share/constants';
import { HOTEL_CONFIRMED_INFO, HOTEL_BOOKING_COMPLETE, HOTEL_PACKAGE_ID } from '@constants';
import { IMarginatorState, setLoginRedirect } from '@share/store/slices';

import { GuestInfo } from '../guest-info-wrapper/guest-info';
import { PaymentMethod } from '../payment-method';
import { ConfirmationEmail } from '../confirmation-email';
import { CancellationPolicies } from '../cancellation-policies';

import { GetPreferenceValue, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY } from '@utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

import { Elements } from '@stripe/react-stripe-js';
import { StripeBtnTypes, stripePromise } from '../../../../../share/utils/stripe';
import { InsuranceRequiredMessage } from '../../../common/insurance/insurance-required-message';

import CustomFieldsCard from '../../../dashboard-hotel-book/custom-fields-card/component';
import ExpressCheckoutButtons from '../../../../../share/components/express-checkout-element/component';
import GlobalLoading from '../../../../../share/components/express-checkout-element/global-spinner/component';

import './style.scss';
import { Alert, Spin } from 'antd';
import { is } from 'date-fns/locale';

interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  redeemCodeStore: ICouponState;
  marginatorStore: IMarginatorState;
  hotelsStore: IHotelsState;
  loginStore: ILoginState;
  insuranceStore: IInsuranceState;
}

interface IMapDispatchToProps {
  getBookPackageWithCard: (bookWithCard: IBookPackageWithCard) => void;
  setGuests: (guests: IGuestsBooking[]) => void;
  setPriceChangedError: (priceChanged: boolean) => void;
  getNavigationMenu: () => AppThunk;
  setBooking: (data: IBookingComplete) => void;
  setBookingComplete: (item: boolean) => void;
  setLoginRedirect: (redirect: string) => void;
}

interface IProps
  extends IMapStateToProps,
  IMapDispatchToProps,
  WrappedComponentProps,
  RouteComponentProps {
  isVacationRentals: boolean;
}

export interface IButtonsComplete {
  guestForm: boolean;
  emailForm: boolean;
  paymentForm: boolean;
}

export interface IMultiplePayments {
  amazonPay: boolean;
  applePay: boolean;
  googlePay: boolean;
  link: boolean;
  paypal: boolean;
}

interface IState {
  isAccept: boolean;
  isCheckMainGuest: boolean;
  isSessionExpired: boolean;
  showNotRefundableMessage: boolean;
  showNotRefundableConfirmModal: boolean;
  isButtonCompleteHidden: IButtonsComplete;
  multiplePayments: IMultiplePayments;
  paymentSelected: string;
  scrollToPaymentSelect: boolean;
  ifEmailChanging: string | undefined
}

const ZERO = 0;
const TEN_SEC = 10000;

class ReviewBookComponent extends React.Component<IProps, IState> {
  state: IState = {
    isAccept: false,
    isCheckMainGuest: true,
    isSessionExpired: false,
    showNotRefundableMessage: false,
    showNotRefundableConfirmModal: false,
    isButtonCompleteHidden: {
      guestForm: false,
      emailForm: false,
      paymentForm: false
    },
    multiplePayments: {
      amazonPay: false,
      applePay: false,
      googlePay: false,
      link: false,
      paypal: false
    },
    paymentSelected: '',
    scrollToPaymentSelect: false,
    ifEmailChanging: undefined
  };

  formPaymentRef = React.createRef<FormInstance>();
  formGuestRef = React.createRef<FormInstance>();
  formEmailRef = React.createRef<FormInstance>();

  insuranceContainerRef = React.createRef<HTMLDivElement>();

  formCustomFieldRef = React.createRef<FormInstance>();

  onChangeAccept = (e: { target: any }): void => {
    this.setState({ isAccept: e.target.checked });
  };

  getGuests = () => {
    return this.props.reviewBookStore.bookingSummary.bookingCard.package.rooms
      .map((room, index) => {
        const guests = [...new Array(room.adultsCount)].map((_, indexGuest) => {
          return indexGuest === ZERO
            ? {
              ...DEFAULT_GUEST_DATA,
              id: v4(),
              isMainGuest: index === ZERO && indexGuest === ZERO,
              allocation: room.id,
              type: 'adult',
            }
            : {
              ...DEFAULT_GUEST_DATA,
              id: v4(),
              allocation: room.id,
              type: 'adult',
            };
        });

        const kids = room.kidsAges.map((kidAge) => {
          return {
            ...DEFAULT_GUEST_DATA,
            id: v4(),
            allocation: room.id,
            type: 'kid',
            age: kidAge,
          };
        });

        return [...guests, ...kids];
      })
      .flat();
  };

  handleOnCompleteBooking = () => {
    const { reviewBookStore, loginStore } = this.props;
    const { account, userWallet } = loginStore;
    const { bookingSummary, selectedHotelReviewClientCash, bookingComplete, booking } = reviewBookStore;
    const { refundability } = bookingSummary.bookingCard?.package;

    const hasClientCash = account?.hasClientCash;
    const walletIsExternal = account?.walletIsExternal;
    const isLogged = !!userWallet;

    const usedClientCash = (bookingComplete && booking) ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;

    const refundabilityFinal = (!walletIsExternal && hasClientCash && isLogged && (selectedHotelReviewClientCash > 0 || usedClientCash > 0)) ? NON_REFUNDABLE_TYPE : refundability;

    if (NON_REFUNDABLE_TYPE === refundabilityFinal) {
      this.setState({ showNotRefundableConfirmModal: true });
    } else {
      this.onCompleteBooking()
    }
  }

  onCompleteBooking = () => {
    const { reviewBookStore, hotelsStore, loginStore } = this.props;
    const { isAccept } = this.state;
    const { bookingSummary, card, guests, loadingBooking, isSoldOutError, selectedHotelReviewClientCash } = reviewBookStore;
    const { referenceNumber, agencyNumber } = hotelsStore;
    const { account, userWallet, userWalletData } = loginStore;
    const { balance } = bookingSummary.bookingCard;

    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;
    const finalBalanceIntermediate = balance - (selectedHotelReviewClientCash ? selectedHotelReviewClientCash * convertionRate : 0);
    const finalBalance = Math.floor(finalBalanceIntermediate * 100) / 100;

    const token = getToken(account);
    const isPrivateWithToken = account?.type === LoginType.PrivateWithToken;

    if (isPrivateWithToken && !token) {
      this.setState({ isSessionExpired: true });
      return;
    }

    if (loadingBooking || isSoldOutError || !isAccept) {
      return;
    }

    const { coupon } = this.props.redeemCodeStore;
    const values = UrlUtils.getValues();
    const sessionKey = getSessionObj(
      values[SESSION_KEY_LABEL_ROOMS] as ISessionKey,
      values[SESSION_KEY_LABEL] as ISessionKey,
    );
    const getLeadPax = guests.find((guest) => guest.isMainGuest);

    if (getLeadPax === undefined) {
      this.setState({ isCheckMainGuest: false });
      window.scrollTo(ZERO, ZERO);
    }
    let quote;
    if (values[QUOTE_LABEL]) {
      quote = (values[QUOTE_LABEL] as string);
    }

    let customFields: any = [];
    if (bookingSummary?.customFields) {
      const fields = [...bookingSummary.customFields];
      fields.map((item) => {
        const value = this.formCustomFieldRef.current?.getFieldValue(item.id);
        if (value) {
          // item = { ...item, value: value };
          customFields.push({ type: item.type, label: item.label, value: value });
        }
      })
    }

    const data: any = {
      sessionKey,
      bookingPrice: bookingSummary?.bookingCard.bookingPrice.payNowPrice,
      hotelId: bookingSummary?.bookingCard.package.hotelId,
      leadPaxId: getLeadPax?.id,
      leadPaxRoomId: getLeadPax?.allocation,
      packageId: bookingSummary?.bookingCard.package.packageId,
      couponCode: coupon,
      marginator:
      {
        percentage: this.props.marginatorStore.percentage,
        commission: this.props.marginatorStore.commission,
        impersonator: {
          memberId: this.props.marginatorStore.impersonator.memberId
        }
      },
      guests: guests.map((guest) => {
        const type: string = guest?.type;

        return {
          ...guest,
          namePrefix: !isEmpty(guest?.namePrefix) ? guest?.namePrefix : 'Mr',
          givenName: !isEmpty(guest?.givenName) ? guest?.givenName : 'TBV',
          surname: !isEmpty(guest?.surname) ? guest?.surname : 'TBV',
          type,
        };
      }),
      referenceNumber,
      agencyNumber,
      currency: getSelectedCurrency(loginStore.account),
      quote,
      customFields: customFields ? customFields : null
    };

    const privateTokenFromUrl = account?.privateTokenFromUrl;
    if (isPrivateWithToken && privateTokenFromUrl) {
      const ssoSessionKey = UrlUtils.getSearchParam(SESSION_KEY_TOKEN_NAME_PARAM);
      data.ssoSessionKey = ssoSessionKey;
      data.lifeType = UrlUtils.getSearchParam(LIFE_STYLE_NAME_PARAM);
    }

    const hasClientCash = account?.hasClientCash;
    const isLogged = !!userWallet;

    const paymentMethod = { paymentMethodId: card?.id, CVC: card?.cvv };
    const creditCard = { ...card, phone: getLeadPax?.phone };

    if (hasClientCash && isLogged) {
      data.clientCashAmount = selectedHotelReviewClientCash ? selectedHotelReviewClientCash : 0;

      if (finalBalance > 0) {
        if (!isEmpty(card?.id)) {
          data.paymentMethod = paymentMethod;
        } else {
          data.card = creditCard;
        }
      }
    } else {
      if (!isEmpty(card?.id)) {
        data.paymentMethod = paymentMethod;
      } else {
        data.card = creditCard;
      }
    }

    this.setFieldsGuestsValue(guests);
    this.formEmailRef.current?.setFieldsValue({ email: this.mainGuestData('email') });
    this.formGuestRef.current?.setFieldsValue({
      mainGuestGivenName: this.mainGuestData('givenName'),
    });
    this.formGuestRef.current?.setFieldsValue({
      mainGuestPhone: this.mainGuestData('phone'),
    });
    this.formGuestRef.current?.setFieldsValue({ mainGuestSurname: this.mainGuestData('surname') });
    this.formPaymentRef.current?.setFieldsValue({ address: card.addressLine });
    this.formPaymentRef.current?.setFieldsValue({ city: card.city });
    this.formPaymentRef.current?.setFieldsValue({ state: card.state });
    this.formPaymentRef.current?.setFieldsValue({ 'postal-code': card.zipCode });

    const formCustomFieldsRef = this.formCustomFieldRef.current?.validateFields();
    const formPaymentRef = this.formPaymentRef.current?.validateFields();
    const formGuestRef = this.formGuestRef.current?.validateFields();
    const formEmailRef = this.formEmailRef.current?.validateFields();

    ReactGA.event({
      category: account?.name as string,
      action: `${C_COMPLETE_BOOKING}_${account?.name.toUpperCase()}`,
      label: `User clicked complete booking on book`,
      nonInteraction: false,
    });

    Promise.all([formCustomFieldsRef, formPaymentRef, formGuestRef, formEmailRef])
      .then(() => {
        this.props.getBookPackageWithCard(data);
      })
      .catch((error: IFormErrors) => {
        const { errorFields } = error;
        const { name } = errorFields[ZERO];

        (() => {
          this.formCustomFieldRef.current?.scrollToField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          this.formEmailRef.current?.scrollToField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          this.formPaymentRef.current?.scrollToField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
          this.formGuestRef.current?.scrollToField(name[ZERO], { behavior: ScrollBehaviorEnum.Smooth });
        })();
      });
  };

  setFieldsGuestsValue = (guests: IGuestsBooking[]): void[] => {
    return guests.map((guest, index) => {
      if (guest.isMainGuest === true) {
        return;
      }

      this.formGuestRef.current?.setFieldsValue({ [`guests[${index}].givenName`]: guest.givenName });
      this.formGuestRef.current?.setFieldsValue({ [`guests[${index}].surname`]: guest.surname });
    });
  };

  handleRedirect = () => {
    const { loginStore } = this.props;
    const { account } = loginStore;

    const logoutUrlStorage = localStorage.getItem(USER_BASE_URL);
    const logoutPref = getPreferenceFromAccount(account, LOGOUT_FIELD_KEY);
    const logoutUrl = !isEmpty(logoutUrlStorage) ? logoutUrlStorage : logoutPref;
    if (!isEmpty(logoutUrl)) {
      window.location.replace(logoutUrl);
    }
  }

  mainGuestData = (item: string): string => {
    const guest = this.props.reviewBookStore.guests.find((item) => item.isMainGuest === true);

    return guest ? (guest[item] as string) : '';
  };

  titleBookingFailed = (): string => {
    return `${this.props.intl.formatMessage({ id: 'your.booking.in' })}
      ${this.props.reviewBookStore.bookingSummary.bookingCard.name}
      ${this.props.intl.formatMessage({ id: 'did.not.go.through' })}`;
  };

  redirectToHotelPage = (): void => {
    const hotelId = getHotelIdFromPath(this.props.history);
    const hotelPath = getHotelRoutePath(hotelId, this.props.history);
    this.props.history.push(hotelPath);
    this.props.setPriceChangedError(false);
  };

  getErrorMessages = () => {
    const { errorsBookingMessage, stripeError } = this.props.reviewBookStore;
    if (!isEmpty(stripeError)) {
      return <p>{stripeError}</p>;
    } else {
      return errorsBookingMessage.map((message, index) => (
        <p key={index}>{message.errorMessage}</p>
      ));
    }
  };

  componentDidMount() {
    this.props.setGuests(this.getGuests());

    if (localStorage.getItem(HOTEL_CONFIRMED_INFO) !== null) {
      const bookingInfo = localStorage.getItem(HOTEL_CONFIRMED_INFO);
      const bookingCompleteInfo = localStorage.getItem(HOTEL_BOOKING_COMPLETE);

      this.props.setBooking(bookingInfo ? JSON.parse(bookingInfo) : null);
      // this.props.setBookingComplete(bookingCompleteInfo ? JSON.parse(bookingCompleteInfo) : null);
    }
  } 


  componentDidUpdate(prevProps: Readonly<IProps>) {
    const { bookingComplete, errorBooking, bookingSummary } = this.props.reviewBookStore;
    const { bookingCard } = bookingSummary;

    if (
      (bookingComplete && bookingComplete !== prevProps.reviewBookStore.bookingComplete) ||
      (errorBooking && errorBooking !== prevProps.reviewBookStore.errorBooking)
    ) {
      localStorage.setItem(HOTEL_PACKAGE_ID, JSON.stringify(bookingCard.package.packageId));
      setTimeout(() => {
        this.props.getNavigationMenu();
      }, TEN_SEC);
    }
  }

  hangleGoToLogin = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.Login}`);
  }

  hangleGoToSignUp = () => {
    const { loginStore, history } = this.props;
    const { account } = loginStore;

    const { pathname, search } = history.location;
    this.props.setLoginRedirect(`${pathname}${isEmpty(search) ? '' : search}`);

    this.props.history.push(`/${account?.name}${Routes.SignUp}`);
  }

  render(): React.ReactNode {
    const { isSessionExpired } = this.state;
    const { reviewBookStore, loginStore, insuranceStore, isVacationRentals, intl } = this.props;
    const isPackage = reviewBookStore.bookingSummary.bookingCard.package.isPackage;
    const {
      card,
      guests,
      loadingBooking,
      bookingComplete,
      bookingSummary,
      isPriceChangedError,
      isSoldOutError,
      errorsBookingMessage,
      isBookingInProgress,
      threeDSLoading,
      selectedHotelReviewClientCash,
      stripeError,
      stripeLoading
    } = reviewBookStore;
    const { account, userWallet, userWalletData } = loginStore;
    const { selection, insurance } = insuranceStore;

    const isNotification =
      bookingComplete ||
      isPriceChangedError ||
      isSoldOutError ||
      isBookingInProgress;

    const currency = bookingSummary?.bookingCard?.package?.currency;
    const { balance, bookingPrice } = bookingSummary.bookingCard;
    const { maxWalletClientCash } = bookingPrice;

    const chargeDescription = GetPreferenceValue(account, MERCHANT_CHARGE_DESCRIPTION_FIELD_KEY);
    const walletNoPassEarnings = account?.walletNoPassEarnings;
    const walletNoDecimals = account?.walletNoDecimals;
    const walletIsExternal = account?.walletIsExternal;

    const hasClientCash = account?.hasClientCash;
    const clientCashPercentage = account?.clientCashPercentage;
    const isLogged = !!userWallet;

    const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

    const balanceInt = balance;
    const maxWalletClientCashInt = maxWalletClientCash;

    const finalBalanceIntermediate = balanceInt - (selectedHotelReviewClientCash ? selectedHotelReviewClientCash : 0) * convertionRate;
    const finalBalance = Math.floor(finalBalanceIntermediate * 100) / 100;
    const eligibleClientCash = (finalBalance > 0 ? finalBalance : 0) * (clientCashPercentage && !isEmpty(clientCashPercentage) ? parseInt(clientCashPercentage) : 0) / 100;
    const isRequired = !hasClientCash || finalBalance > 0;
    const balanceCalculated = balanceInt / convertionRate;

    const maxWalletClientCashCalculated = maxWalletClientCashInt ? walletNoDecimals ? Math.floor(maxWalletClientCashInt / convertionRate) : maxWalletClientCashInt / convertionRate : null;
    const userWalletDataBalanceCalculated = (walletNoDecimals && userWalletData?.balance) ? Math.floor(userWalletData?.balance) : userWalletData?.balance;
    const maxWalletAmountIntermediated = walletNoPassEarnings ?
      maxWalletClientCashCalculated ?
        (maxWalletClientCashCalculated && (userWalletDataBalanceCalculated || 0) > maxWalletClientCashCalculated) ?
          maxWalletClientCashCalculated :
          userWalletDataBalanceCalculated :
        0 :
      (userWalletDataBalanceCalculated || 0) > balanceCalculated ?
        balanceCalculated :
        userWalletDataBalanceCalculated;

    const maxWalletAmount = (maxWalletClientCashCalculated && (maxWalletAmountIntermediated || 0) > maxWalletClientCashCalculated) ? maxWalletClientCashCalculated : maxWalletAmountIntermediated;

    const clientCash = selectedHotelReviewClientCash ? GetWalletNumber(selectedHotelReviewClientCash, account) : Number(0).toFixed(walletNoDecimals ? 0 : 2);

    const insuranceBalance = (selection === InsuranceSelection.YES && !!insurance?.productDetails?.price) ? insurance?.productDetails?.price : 0;
    const isInsuranceSelected = (selection === InsuranceSelection.YES && !!insurance?.productDetails?.price);

    const handleGuestFormValidation = (guestForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          guestForm,
        },
      }));
    };

    const handleEmailFormValidation = (emailForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          emailForm,
        },
      }));
    };

    const handlePaymentFormValidation = (paymentForm: boolean): void => {
      this.setState((prevState: IState) => ({
        ...prevState,
        isButtonCompleteHidden: {
          ...prevState.isButtonCompleteHidden,
          paymentForm,
        },
      }));
    };

    const scrollToPaymentSelectDisabled = () => this.setState({ scrollToPaymentSelect: false });

    const setPaymentSelected = (payment: string) => {
      this.setState((prevState: IState) => ({
        ...prevState,
        paymentSelected: payment,
      }));
    };

    const isCardPayment = !isEmpty(this.state.paymentSelected) && this.state.paymentSelected === 'card';
    const isOtherPayment = !isEmpty(this.state.paymentSelected) && this.state.paymentSelected !== 'card';

    const keysToValidate: Array<keyof IButtonsComplete> =
      isCardPayment
        ? ['guestForm', 'emailForm', 'paymentForm'] // If 'card', include all three forms
        : ['guestForm', 'emailForm']; // If not 'card', only include guestForm and emailForm

    // Validate only the selected keys
    //VALIDATE THE SELECT PAYMENT FORM
    const VALIDATE_STRIPE_BTNS = !isEmpty(this.state.paymentSelected) ? (keysToValidate.every(
      (key) => this.state.isButtonCompleteHidden[key] === true)) : false;

    const parsedTotalInt = finalBalance + insuranceBalance;
    const parsedTotal = parseFloat(
      renderNumber(parsedTotalInt, 2).replace(/,/g, ''),
    );

    const setMultiplePayments = (payments: any) => {
      this.setState((prevState: IState) => ({
        ...prevState,
        multiplePayments: {
          ...payments
        },
      }));
    };

    const validateForm = () => {
      const formGuestRef = this.formGuestRef.current?.validateFields();
      const formEmailRef = this.formEmailRef.current?.validateFields();
      const formPaymentRef = this.formPaymentRef.current?.validateFields();
      let promises = [formGuestRef, formEmailRef];
      const shouldIncludePayment = isCardPayment;

      if (shouldIncludePayment) {
        promises.push(formPaymentRef);
      } else {
        promises = [formGuestRef, formEmailRef];
      }

      if (isEmpty(this.state.paymentSelected)) {
        this.setState({ scrollToPaymentSelect: true })
        const paymentSection = document.getElementById("payment-methods-select__card");
        if (paymentSection) {
          paymentSection.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        scrollToPaymentSelectDisabled();
      }

      Promise.all(promises)
        .catch((error: IFormErrors) => {
          const { errorFields } = error;
          const { name } = errorFields[0];

          this.formGuestRef.current?.scrollToField(name[0], { behavior: ScrollBehaviorEnum.Smooth });
          this.formEmailRef.current?.scrollToField(name[0], { behavior: ScrollBehaviorEnum.Smooth });

          if (shouldIncludePayment && this.formPaymentRef.current) {
            const { scrollToField: scrollToPaymentField } = this.formPaymentRef.current;
            scrollToPaymentField(name[0], { behavior: ScrollBehaviorEnum.Smooth });
          }
        });
    };

    const enableInsurance = account?.enableInsurance;

    return (
      guests && (
        <>
          <div className={`vstack gap-5 review-book p-0 ${isNotification ? 'hide-block' : ''}`}>
            {errorsBookingMessage && errorsBookingMessage.length || !isEmpty(stripeError) && (
              <Alert
                message={<FormattedMessage id="transaction.failed" />}
                description={this.getErrorMessages()}
                type="error"
                showIcon
              />
            )}

            <GuestInfo formRef={this.formGuestRef} isCheckMainGuest={this.state.isCheckMainGuest} handleGuestFormValidation={handleGuestFormValidation} />

            {bookingSummary?.customFields
              ?
              <CustomFieldsCard
                formInstance={this.formCustomFieldRef}
                customFields={bookingSummary.customFields}
              />
              : null
            }

            <PaymentMethod
              formRef={this.formPaymentRef}
              display={finalBalance > 0}
              isRequired={isRequired}
              multiplePayments={this.state.multiplePayments}
              setPaymentSelected={setPaymentSelected}
              paymentSelected={this.state.paymentSelected}
              handlePaymentFormValidation={handlePaymentFormValidation}
              scrollToPaymentSelect={this.state.scrollToPaymentSelect}
              scrollToPaymentSelectDisabled={scrollToPaymentSelectDisabled}
              availableNewFlow={true}
            />

            {!card?.id && isCardPayment ? (
              <div className="review-book__wrapper" ref={this.insuranceContainerRef}>
                <Insurance />
              </div>) : null}

            {bookingSummary.providerMessage &&
              <div className="card shadow">
                <div className="card-header border-bottom p-4">
                  <h4 className="card-title mb-0">
                    <i className="bi bi-exclamation-square me-2"></i><FormattedMessage id="important.information" />
                  </h4>
                </div>
                <div className="card-body p-4">
                  <div className="col-12 ">
                    <label className="form-label">
                      <span className="h6 fw-normal">{parse(bookingSummary.providerMessage)}</span>
                    </label>
                  </div>
                </div>
              </div>
            }

            <div className="card shadow">
              <div className="card-body p-4">

                <ConfirmationEmail formRef={this.formEmailRef} value={this.mainGuestData('email')} handleEmailFormValidation={handleEmailFormValidation} />

                <CancellationPolicies noBorders />

                <div className="form-check ps-0 pt-0 pb-2">
                  <div className="cancellation-policies__header policy">
                    <label className="form-label pt-3 cancellation-policies__title secondary-font">
                      <span className="h6 fw-normal bold-heading"><FormattedMessage id="review.booking.terms.title" /></span>
                    </label>
                  </div>                  
                </div>

                <div className="form-check ps-0 pb-2">
                  <label className="" style={{ display: 'flex' }}>
                    <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                    <FormattedMessage
                      id="accept.you.will.be.charged"
                      values={{
                        price: renderNumber(finalBalance + insuranceBalance, 2),
                        type: <FormattedMessage id="hotel" />,
                        reservation_name: (!isEmpty(chargeDescription) && bookingSummary?.customProvider) ? chargeDescription : <FormattedMessage id="accept.you.will.be.charged.travcoding" />,
                        currency: currency
                      }}
                    />
                  </label>
                </div>

                <div className="form-check ps-0 pb-2">
                  <label className="" style={{ display: 'flex' }}>
                    <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                    <FormattedMessage id="accetp.no.changes.allow" />
                  </label>
                </div>

                <div className="form-check ps-0 pb-2">
                  <label className="" style={{ display: 'flex',cursor: 'default' }}>
                    <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                    <FormattedMessage id="by.checking.this.box.you.acknowledge.that.you.have.read" />
                  </label>
                </div>

                {isPackage && account?.isTravelAgentPro &&
                  <div className="form-check ps-0 pb-2">
                    <label className="" style={{ display: 'flex' }}>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                      <FormattedMessage id="checkout.package.message" />
                    </label>
                  </div>}

                {hasClientCash && isLogged &&
                  <div className="form-check ps-0 pb-2">
                    <label className="form-check-label" style={{ display: 'flex',cursor: 'default' }}>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                      {!walletIsExternal ?
                        (<FormattedMessage id="wallet.client.cash.by.checking.acknowledge" values={{ clientCash, reward: walletNoDecimals ? Math.floor(eligibleClientCash).toFixed(0) : eligibleClientCash.toFixed(2), clientCashPercentage: clientCashPercentage, clientCashName: account?.walletClientCashName }} />) :
                        (<FormattedMessage id="wallet.client.cash.by.checking.acknowledge.external" values={{ clientCash, clientCashName: account?.walletClientCashName }} />)}
                    </label>
                  </div>}

                {!walletIsExternal && hasClientCash && isLogged && selectedHotelReviewClientCash > 0 &&
                  <div className="form-check ps-0 pb-2">
                    <label className="form-check-label" style={{ display: 'flex' }}>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                      <FormattedMessage id="wallet.client.not_refundable.acknowledge" values={{ clientCash, clientCashName: account?.walletClientCashName }} />
                    </label>
                  </div>}

                {isInsuranceSelected ? (
                  <div className="review-book__wrapper">
                    <p className="review-book__accept-text" style={{ display: 'flex' }}>
                      <FontAwesomeIcon icon={faCheck} style={{ color: '#1d2f67', marginRight: '10px', paddingTop: '3px' }} />
                      <FormattedMessage id="insurance.policy.disclaimer" />
                    </p>
                  </div>) : null}

                {hasClientCash && !isLogged &&
                  <div className="review-book__wrapper client-cash-message">
                    <p className="review-book__accept-text">
                      <FontAwesomeIcon icon={faTriangleExclamation} />{' '}<FormattedMessage id="wallet.client.not_logged.acknowledge" values={{ reward: eligibleClientCash.toFixed(2), currency: currency, clientCashPercentage: clientCashPercentage, clientCashName: account?.walletClientCashName }} />
                    </p>
                    <p className="booking-confirmed__contact-property" style={{ fontSize: '18px', marginTop: '10px', textAlign: 'right' }}>
                      <BlueButton onClick={this.hangleGoToLogin}><FormattedMessage id="sign.in" /></BlueButton> <FormattedMessage id="or" /> <BlueButton onClick={this.hangleGoToSignUp}><FormattedMessage id="sign.up" /></BlueButton>
                    </p>
                  </div>}

                <div className="form-check pt-4 pb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="chargeAcknowledged"
                    onChange={this.onChangeAccept}
                    disabled={loadingBooking}
                    style={{ cursor: 'pointer' }} 
                  />
                  <label className="form-check-label" style={{cursor: 'default'}}>
                    <FormattedMessage id="by.checking.this.box.you.acknowledge" />
                  </label>
                </div>

                {!VALIDATE_STRIPE_BTNS && 
                  <p className='payment-complete-fields'><FormattedMessage id="fill.in.all.required.fields" />
                    <u onClick={validateForm} style={{ cursor: 'pointer' }}>(<FormattedMessage id="view.fields" />)</u>
                  </p>}

                {isCardPayment && (
                  <InsuranceRequiredMessage
                    display={(!card?.id && enableInsurance && insurance && (selection === null || selection === undefined)) as boolean}
                    insuranceContainerRef={this.insuranceContainerRef}
                    classNameContainer="review-book__wrapper"
                  />)}

                <div className="review-book__wrapper">
                  <div className="col-12 ">
                    <div className="d-sm-flex justify-content-sm-between align-items-center">
                      <h4 className="text-success">
                        <Currency currency={currency} />{renderNumber(finalBalance + insuranceBalance, 2)} <span className="small fs-6"><FormattedMessage id="due.now" /></span>
                      </h4>

                      <>
                        {parsedTotal > 0 && (
                          <div style={{ display: isOtherPayment ? 'block' : 'none' }}>
                            <Elements
                              stripe={stripePromise}
                              options={{
                                mode: 'payment',
                                amount: Math.ceil(parsedTotal * 100),
                                currency: account?.currency?.toLocaleLowerCase(),
                              }}
                            >
                              <ExpressCheckoutButtons
                                totalPrice={parsedTotal}
                                formsRef={{ formCustomFieldRef: this.formCustomFieldRef }}
                                isDisabled={
                                  !VALIDATE_STRIPE_BTNS ||
                                  isSoldOutError ||
                                  (isPackage && account?.isTravelAgentPro) ||
                                  isInsuranceSelected ||
                                  loadingBooking ||
                                  !this.state.isAccept ||
                                  (hasClientCash && isLogged && selectedHotelReviewClientCash > (maxWalletAmount || 0)) ||
                                  (hasClientCash && isLogged && !!selectedHotelReviewClientCash && selectedHotelReviewClientCash <= (maxWalletAmount || 0) && walletNoDecimals && Math.floor(selectedHotelReviewClientCash) != selectedHotelReviewClientCash)
                                }
                                type={StripeBtnTypes.Hotel}
                                setMultiplePayments={setMultiplePayments}
                                paymentSelected={this.state.paymentSelected}
                              />
                            </Elements>
                          </div>)}

                        {isCardPayment && (<BlueButton
                          onClick={this.handleOnCompleteBooking}
                          className={`btn mh-40 btn-primary mb-0 button-width ${loadingBooking ? 'btn-disabled' : ''}`} 
                          disabled={
                            !VALIDATE_STRIPE_BTNS ||
                            isSoldOutError ||
                            (isPackage && account?.isTravelAgentPro) ||
                            isInsuranceSelected ||
                            loadingBooking ||
                            !this.state.isAccept ||
                            (hasClientCash && isLogged && selectedHotelReviewClientCash > (maxWalletAmount || 0)) ||
                            (hasClientCash && isLogged && !!selectedHotelReviewClientCash && selectedHotelReviewClientCash <= (maxWalletAmount || 0) && walletNoDecimals && Math.floor(selectedHotelReviewClientCash) != selectedHotelReviewClientCash)
                          }
                        >
                          {loadingBooking ? <Spin size="small" /> : `Pay Now`}
                        </BlueButton>)}
                      </>

                    </div>
                  </div>
                </div>

              </div>

              <div className="card-footer p-4 pt-0">
                <p className="mb-0">
                  <FormattedMessage id="accept.terms" /> <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/terms-of-use/"><FormattedMessage id="footer.ourCompany.termsOfUse" /></a> <FormattedMessage id="and" /> <a target="_blank" rel="noreferrer" href="https://www.travcoding.com/privacy-policy/"><FormattedMessage id="privacy.policy" /></a>
                </p>
              </div>
            </div>

          </div>

          {isBookingInProgress && <ReservationProgress isBookingInProgress={isBookingInProgress} />}

          <BookingConfirmed
            isBookingComplete={bookingComplete}
            isVacationRentals={isVacationRentals}
            packageData={reviewBookStore}
          />

          <ModalConfirmation
            message="non.refundable.reservation.message"
            title="non.refundable.reservation"
            yesMessage="yes"
            noMessage="no"
            visible={this.state.showNotRefundableConfirmModal}
            onCancel={() => this.setState({ showNotRefundableConfirmModal: false })}
            onConfirm={() => this.setState({ showNotRefundableConfirmModal: false }, this.onCompleteBooking)}
          />

          {isPriceChangedError && (
            <BookingFailed
              title={intl.formatMessage({ id: 'price.changed' })}
              description={intl.formatMessage({ id: 'unable.to.confirm.booking' })}
              buttonTitle={intl.formatMessage({ id: 'book.another.room' })}
              onClick={this.redirectToHotelPage}
              isPriceChangedError={isPriceChangedError}
              isVacationRentals={isVacationRentals}
            />
          )}

          {isSoldOutError && (
            <BookingFailed
              title={this.titleBookingFailed()}
              isVacationRentals={isVacationRentals}
              description={intl.formatMessage({ id: 'sorry.we.were.unable.to.confirm' })}
              buttonTitle={intl.formatMessage({ id: 'start.searching' })}
              onClick={this.redirectToHotelPage}
            />
          )}

          <ReviewBookPriceChangeModal isVacationRentals={isVacationRentals} />
          <AvailabilityStatusModal isVacationRentals={isVacationRentals} />
          <ThreeDSModal />

          {threeDSLoading ? (
            <div className="review-book__loading-container">
              <Loading size={LoadingSise.Small} />
            </div>) : null}

          {isSessionExpired && (
            <div className="result-wrapper__expired-message">
              <ExpiredSessionModal visible={isSessionExpired} hasRedirect={true} onHandleRedirect={this.handleRedirect} />
            </div>)}

          <GlobalLoading isVisible={stripeLoading} />
        </>
      )
    );
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    redeemCodeStore: state.redeemCodeStore,
    marginatorStore: state.marginatorStore,
    hotelsStore: state.hotelsStore,
    loginStore: state.loginStore,
    insuranceStore: state.insuranceStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getBookPackageWithCard,
  setGuests,
  setPriceChangedError,
  getNavigationMenu,
  setBooking,
  setBookingComplete,
  setLoginRedirect,
};

export const ReviewBook = connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(ReviewBookComponent)));
